import { ReactComponent as SvgZignalyIsotype } from '../../../../../assets/images/zignaly-isotype.svg.js';
import { ReactComponent as SvgZignalyLogotype } from '../../../../../assets/images/zignaly-logotype.svg.js';

var iconsByType = {
    isotype: SvgZignalyIsotype,
    logotype: SvgZignalyLogotype,
};

export { iconsByType };
